
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingPages/NewsLandingPage",
      function () {
        return require("private-next-pages/landingPages/NewsLandingPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingPages/NewsLandingPage"])
      });
    }
  